import React from 'react'
import styles from './SidebarSection.module.scss'

type Variant = 'header' | 'nav' | 'footer'

interface SidebarSectionProps {
  children: React.ReactNode
  variant: Variant
  className?: never
}

const variantMap: Record<Variant, string> = {
  header: styles.header, nav: styles.nav, footer: styles.footer,
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({ children, variant }) => {
  const Tag = variant === 'nav' ? 'nav' : 'div'
  return <Tag className={variantMap[variant]}>{children}</Tag>
}
